import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Button } from '@mui/material';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';

type Props = Record<string, never>;

export function EditorExpander(p: Props) {
  const isExpanded = useFragmentEditorStore((state) => state.isExpanded);
  const toggleExpanded = useFragmentEditorStore((state) => state.toggleExpanded);

  return (
    <Button size="small" variant="outlined" onClick={toggleExpanded}>
      {isExpanded ? (
        <KeyboardArrowDownIcon sx={{ fontSize: 'inherit' }} />
      ) : (
        <KeyboardArrowUpIcon sx={{ fontSize: 'inherit' }} />
      )}
    </Button>
  );
}
